import * as types from '../action-types';
import { HighlightReducerType } from '../decisionState.types';
import { HighlightActions } from '../actions';

const initialState: HighlightReducerType = {
  isOpen: false,
  top: -9999,
  left: 0,
};

export function highlightReducer(
  state: HighlightReducerType = initialState,
  action: HighlightActions,
) {
  switch (action.type) {
    case types.openHighlightPopover: {
      const { data } = action.payload;
      return { ...state, ...data };
    }
    case types.closeHighlightPopover: {
      return {
        ...state,
        isOpen: false,
        top: -9999,
      };
    }
    default: {
      return state;
    }
  }
}
